/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../ui_elements/ui_element';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "CompletionStatusScreen": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "glyph": {
                        "type": ".squareup.bbfrontend.service.v1.CompletionStatusScreen.StatusGlyph",
                        "id": 2,
                        "rule": "optional"
                      },
                      "title": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "message": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "completionButton": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement.ButtonElement",
                        "id": 5,
                        "rule": "optional"
                      },
                      "automaticDismissalBehavior": {
                        "type": ".squareup.bbfrontend.service.v1.CompletionStatusScreen.AutomaticDismissalBehavior",
                        "id": 6,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "AutomaticDismissalBehavior": {
                        "fields": {
                          "millisecondDelay": {
                            "type": "double",
                            "id": 1,
                            "rule": "optional",
                            "options": {
                              "default": 1000.0
                            }
                          }
                        }
                      },
                      "StatusGlyph": {
                        "values": {
                          "STATUS_GLYPH_DO_NOT_USE": 0,
                          "SUCCESS": 1,
                          "FAILURE": 2
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CompletionStatusScreen && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CompletionStatusScreen?.nested?.AutomaticDismissalBehavior && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CompletionStatusScreen?.nested?.StatusGlyph) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CompletionStatusScreen @ squareup/bbfrontend/common/workflow/screens/completion_status_screen.proto at 12:1
 */
export const CompletionStatusScreen = $root.lookupType('squareup.bbfrontend.service.v1.CompletionStatusScreen');
fixType(CompletionStatusScreen, {
  id: {
    required: true
  },
  glyph: {
    required: true
  },
  title: {
    required: true
  },
  completionButton: {
    required: true
  }
});
Builder.createAndAttachToType(CompletionStatusScreen);
/**
 * SOURCE AutomaticDismissalBehavior @ squareup/bbfrontend/common/workflow/screens/completion_status_screen.proto at 29:3
 */
CompletionStatusScreen.AutomaticDismissalBehavior = $root.lookupType('squareup.bbfrontend.service.v1.CompletionStatusScreen.AutomaticDismissalBehavior');
fixType(CompletionStatusScreen.AutomaticDismissalBehavior);
Builder.createAndAttachToType(CompletionStatusScreen.AutomaticDismissalBehavior);
/**
 * SOURCE StatusGlyph @ squareup/bbfrontend/common/workflow/screens/completion_status_screen.proto at 38:3
 */
CompletionStatusScreen.StatusGlyph = $root.lookupEnum('squareup.bbfrontend.service.v1.CompletionStatusScreen.StatusGlyph').values;